import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import PageHeaderMeta from '~/components/common/PageHeaderMeta';
import manpic from '~/images/andrika_cat_thumb.jpg';
import womanpic from '~/images/gynaikeia_cat_thumb.jpg';
import kidpic from '~/images/paidika_cat_thumb.jpg';

const NotFound = () => {
	const { t, i18n } = useTranslation();
	const navigate = useNavigate();
	return (
		<>
			<PageHeaderMeta page_title={'404'} status={404} />

			<div id="main-wrapper" className="full-background notfound">
				<div className="content-wrapper narrow-wrapper">
					<h1>{t('title_not_found')}</h1>
					<p>{t('text_not_found')}</p>
					<button type="button" onClick={e => navigate('/')} className="backtohome-button">
						<svg xmlns="http://www.w3.org/2000/svg" width="12.379" height="12.69" viewBox="0 0 12.379 12.69">
							<g id="Icon_feather-arrow-right" data-name="Icon feather-arrow-right" transform="translate(19.879 19.659) rotate(180)">
								<path
									id="Path_38024"
									data-name="Path 38024"
									d="M7.5,18H19.129"
									transform="translate(0 -4.685)"
									fill="none"
									stroke="#fff"
									strokeLinejoin="round"
									strokeWidth="1.5"
								/>
								<path
									id="Path_38025"
									data-name="Path 38025"
									d="M18,7.5l5.815,5.815L18,19.129"
									transform="translate(-4.685)"
									fill="none"
									stroke="#fff"
									strokeLinejoin="round"
									strokeWidth="1.5"
								/>
							</g>
						</svg>

						{t('back_to_home')}
					</button>

					<div className="main-categories-banner">
						<div className="category-wrapper">
							<img src={womanpic} alt="main-image-category" />
							<button type="button" onClick={e => navigate('/categories/adult-gunaika')} className="viewall-button">
								{t('women')}
								<svg xmlns="http://www.w3.org/2000/svg" width="12.379" height="12.69" viewBox="0 0 12.379 12.69">
									<g id="Icon_feather-arrow-right" data-name="Icon feather-arrow-right" transform="translate(-7.5 -6.97)">
										<path
											id="Path_38024"
											data-name="Path 38024"
											d="M7.5,18H19.129"
											transform="translate(0 -4.685)"
											fill="none"
											stroke="#fff"
											strokeLinejoin="round"
											strokeWidth="1.5"
										/>
										<path
											id="Path_38025"
											data-name="Path 38025"
											d="M18,7.5l5.815,5.815L18,19.129"
											transform="translate(-4.685)"
											fill="none"
											stroke="#fff"
											strokeLinejoin="round"
											strokeWidth="1.5"
										/>
									</g>
								</svg>
							</button>
						</div>

						<div className="category-wrapper">
							<img src={manpic} alt="main-image-category" />
							<button type="button" onClick={e => navigate('/categories/adult-andras')} className="viewall-button">
								{t('men')}
								<svg xmlns="http://www.w3.org/2000/svg" width="12.379" height="12.69" viewBox="0 0 12.379 12.69">
									<g id="Icon_feather-arrow-right" data-name="Icon feather-arrow-right" transform="translate(-7.5 -6.97)">
										<path
											id="Path_38024"
											data-name="Path 38024"
											d="M7.5,18H19.129"
											transform="translate(0 -4.685)"
											fill="none"
											stroke="#fff"
											strokeLinejoin="round"
											strokeWidth="1.5"
										/>
										<path
											id="Path_38025"
											data-name="Path 38025"
											d="M18,7.5l5.815,5.815L18,19.129"
											transform="translate(-4.685)"
											fill="none"
											stroke="#fff"
											strokeLinejoin="round"
											strokeWidth="1.5"
										/>
									</g>
								</svg>
							</button>
						</div>

						<div className="category-wrapper">
							<img src={kidpic} alt="main-image-category" />
							<button type="button" onClick={navigate('/categories/kids')} className="viewall-button">
								{t('kids')}
								<svg xmlns="http://www.w3.org/2000/svg" width="12.379" height="12.69" viewBox="0 0 12.379 12.69">
									<g id="Icon_feather-arrow-right" data-name="Icon feather-arrow-right" transform="translate(-7.5 -6.97)">
										<path
											id="Path_38024"
											data-name="Path 38024"
											d="M7.5,18H19.129"
											transform="translate(0 -4.685)"
											fill="none"
											stroke="#fff"
											strokeLinejoin="round"
											strokeWidth="1.5"
										/>
										<path
											id="Path_38025"
											data-name="Path 38025"
											d="M18,7.5l5.815,5.815L18,19.129"
											transform="translate(-4.685)"
											fill="none"
											stroke="#fff"
											strokeLinejoin="round"
											strokeWidth="1.5"
										/>
									</g>
								</svg>
							</button>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default NotFound;
